import {
  Plugin,
} from 'ckeditor5';
import EditorStateCommand from 'views/EMR/components/ckeditor-plugins/EditorState/command';

export default class EditorStateEditing extends Plugin {
  static get pluginName() {
    return 'EditorStateEditing' as const;
  }

  init() {
    this.editor.commands.add('editorState', new EditorStateCommand(this.editor));
  }
}
